import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ClosePopup from '../assets/ClosePopup';
import SandTime2 from '../assets/sandtime-2.svg';
import { useNavigate } from 'react-router-dom';

const Popup = ({ show, onClose, changeModal }) => {
  // function scrollToBusiness() {
  //   const businessElement = document.getElementById('business');
  //   if (businessElement) {
  //     businessElement.scrollIntoView({ behavior: 'smooth' });
  //   }
  //   onClose();
  //   setTimeout(() => {
  //     changeModal({
  //       show: true,
  //       data: {
  //         fullname: '',
  //         businessname: '',
  //         location: '',
  //         website: '',
  //         countrycode: '+961',
  //         phone: '',
  //         businessemail: '',
  //       },
  //     });
  //   }, 1000);
  // }

  // useEffect(() => {
  //   if (show) {
  //     document.body.style.overflow = 'hidden';
  //   } else {
  //     document.body.style.overflow = 'unset';
  //   }

  //   return () => {
  //     document.body.style.overflow = 'unset';
  //   };
  // }, [show]);

  const x = useNavigate();
  function gotoRegisterPage() {
    onClose();
    x('/externalBusinessRequest');
  }

  const popupAnimation = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
    exit: { opacity: 0, scale: 0.5, transition: { duration: 0.3 } },
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className='Popup'
          initial='hidden'
          animate='visible'
          exit='exit'
          variants={popupAnimation}
          style={{ visibility: 'visible', opacity: '1' }}>
          <div>
            <div
              style={{
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
              }}>
              <div className='Popup-x-btn' onClick={onClose}>
                <ClosePopup width={50} height={50} />
              </div>

              <div className='Popup-main'>
                <div className='Popup-row'>
                  <img
                    src={SandTime2}
                    width={128}
                    height={128}
                    alt='SandTime2'
                  />
                </div>
                <div className='Popup-row'>
                  <h1>
                    ARE YOU <br /> A BUSINESS?
                  </h1>
                </div>
                <div className='Popup-row'>
                  <p>
                    🚀 Register Now And Enjoy Your{' '}
                    <span className='Popup-Sub'>free Trial Period </span>
                    With Full Access to All Features!
                  </p>
                </div>
                <div
                  className='Popup-btn'
                  onClick={gotoRegisterPage}
                  style={{
                    marginTop: 10,
                    backgroundColor: 'white',
                    color: '#008a80',
                    opacity: 1,
                  }}>
                  <p
                    style={{
                      color: '#008a80',
                      margin: 0,
                      fontFamily: 'Hurme',
                    }}>
                    Join TheBooker Now
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Popup;
